var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"flex"}},[_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-sm",attrs:{"title":"تایید تراکنش و اضافه کردن به تراکنش های سامانه"},on:{"click":function($event){$event.preventDefault();return _vm.toggleCheck.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-check"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }